<template>
  <div>
    <customize-page
      label-position="left"
      ref="page"
      inline
      :loading="loading"
      :data="dataList"
      :columns="columns"
      :pagination="pagination"
      :formConfig="getFormConfig()"
      :filterObj="filterObj"
      :hideOperate="true"
      @size-change="handleSizeChange"
      @on-selection-change="selectionChange"
      @current-change="handleCurrentChange"
    >
      <div slot="footer">
        <el-button style="margin-right: 10px" type="primary" @click="search">
          搜索
        </el-button>
        <el-button style="margin-right: 10px" @click="reset">重置</el-button>
        <el-button style="margin-left: 20px" type="primary" @click="exportList"
          >导出
        </el-button>
      </div>
    </customize-page>
  </div>
</template>

<script>
import CustomizePage from "@/components/customize-page";
import Page from "@/mixin/Page";

import { mapActions, mapState, mapGetters } from "vuex";
import authApi from "@/api/auth";
import fluxWmsStockApi from "@/api/FluxWmsStockApi";
import * as XLSX from "xlsx";

export default {
  components: {
    CustomizePage,
  },
  mixins: [Page],
  created() {
    let initParam = this.$store.state.app.sc["customerStockList"];
    if (initParam) {
      this.pagination.currentPage = initParam.request.pageIndex;
      this.pagination.pageSize = initParam.request.pageSize;
      this.pagination.pageSizes = [1000];
      this.filterObj = initParam.request.condition;
    }
    authApi.getOmsUserInfo().then((res) => {
      this.userInfo = res;
      this.fetch();
    });
  },
  mounted() {
    this.lists({
      request: {
        currentPage: 1,
        pageSize: 1000,
      },
    });
  },
  data() {
    return {
      loading: false,
      dataList: [],
      userInfo: {},
      columns: [
        {
          title: "货主id",
          key: "customerId",
          align: "center",
        },
        {
          title: "商品条码/料号",
          key: "sku",
          align: "center",
        },
        {
          title: "原产国",
          key: "origin",
          align: "center",
        },
        {
          title: "备案序号",
          key: "itemRecordNo",
          align: "center",
        },
        {
          title: "商品名称",
          key: "name",
          align: "center",
        },
        {
          title: "质量类型",
          key: "lotAtt01",
          align: "center",
          render: (h, params) => {
            let row = params.row;
            if (row.lotAtt08 === "N") {
              return (
                <div>
                  <el-tag size="mini" type="success">
                    正
                  </el-tag>
                </div>
              );
            }

            return (
              <div>
                <el-tag size="mini" type="danger">
                  残
                </el-tag>
              </div>
            );
          },
        },
        {
          title: "批次号",
          key: "userDefine3",
          align: "center",
        },
        {
          title: "生产日期",
          key: "lotAtt01",
          align: "center",
        },
        {
          title: "失效日期",
          key: "lotAtt02",
          align: "center",
        },
        {
          title: "实物库存数",
          key: "qty",
          align: "center",
          render: (h, params) => {
            let row = params.row;
            return (
              <div>
                <span>{parseInt(row.qty)}</span>
              </div>
            );
          },
        },
        {
          title: "可用库存数",
          key: "userDefine1",
          align: "center",
          render: (h, params) => {
            let row = params.row;
            return (
              <div>
                <span>{parseInt(row.userDefine1)}</span>
              </div>
            );
          },
        },
        {
          title: "占用数",
          key: "userDefine2",
          align: "center",
          render: (h, params) => {
            let row = params.row;
            return (
              <div>
                <span>{parseInt(row.userDefine2)}</span>
              </div>
            );
          },
        },
      ],
      filterObj: {
        customerId: "",
        sku: "",
      },
      currentRow: [],
    };
  },
  computed: {
    ...mapState("record", {
      list: "list",
    }),
    ...mapGetters({
      getCustomerList: "getCustomerList",
    }),
  },
  methods: {
    ...mapActions("record", [
      "lists",
      "edit",
      "import",
      "queryList",
      "preview",
      "customerExport",
    ]),
    // 分页加载退货订单列表
    fetch() {
      this.loading = true;
      const filterParams = Object.assign({}, this.getFilterParams());
      let customerId = this.userInfo.customerId || filterParams.customerId;
      if (!customerId) {
        this.loading = false;
        return;
      }

      fluxWmsStockApi
        .querySkuStock({
          request: {
            customerId,
            sku: filterParams.sku,
            warehouseId: "WH01",
            pageNo: this.pagination.currentPage,
            pageSize: this.pagination.pageSize,
          },
        })
        .then((res) => {
          this.loading = false;
          if (filterParams.name) {
            this.dataList = res.item.filter(
              (item) => item.name.indexOf(filterParams.name) > -1
            );
          } else {
            this.dataList = res.item;
          }
          this.pagination.totalCount = 1 * res.totalCount;
        })
        .catch(() => {
          this.loading = false;
          this.dataList = [];
        });
    },
    getFormConfig() {
      const type = this.getFormItemType();
      const customerIdQueryList = [];
      if (!this.userInfo.customerId) {
        customerIdQueryList.push({
          label: "货主id",
          model: "customerId",
          type: type.SELECT,
          props: {
            data: this.getCustomerList.filter((c) => c.type === "NORMAL"),
          },
        });
      }
      return [
        {
          data: [
            ...customerIdQueryList,
            {
              label: "商品条码",
              model: "sku",
              type: type.INPUT,
            },
            {
              label: "商品名称",
              model: "name",
              type: type.INPUT,
            },
          ],
        },
      ];
    },
    selectionChange(rows) {
      this.currentRow = rows;
    },
    // 导出列表
    async exportList() {
      this.loading = true;
      const filterParams = Object.assign({}, this.getFilterParams());
      const data = [
        [
          "商品条码/料号",
          "原产国",
          "备案序号",
          "商品名称",
          "质量类型",
          "批次号",
          "生产日期",
          "失效日期",
          "实物库存数",
          "可用库存数",
          "占用数",
        ],
      ];
      let customerId = this.userInfo.customerId || filterParams.customerId;
      if (!customerId) {
        this.loading = false;
        this.$message.error("请选择货主");
        return;
      }

      try {
        let pageNo = 1;
        const res = await fluxWmsStockApi.querySkuStock({
          request: {
            customerId,
            sku: filterParams.sku,
            warehouseId: "WH01",
            pageNo,
            pageSize: 1000,
          },
        });

        const totalCount = res.totalCount;
        const totalPage = Math.ceil(totalCount / 1000);

        for (let i = 1; i <= totalPage; i++) {
          const r = await fluxWmsStockApi.querySkuStock({
            request: {
              customerId,
              sku: filterParams.sku,
              warehouseId: "WH01",
              pageNo: i,
              pageSize: 1000,
            },
          });
          r.item.forEach((item) => {
            data.push([
              item.sku,
              item.origin,
              item.itemRecordNo,
              item.name,
              item.lotAtt08 === "N" ? "正" : "残",
              item.userDefine3,
              item.lotAtt01,
              item.lotAtt02,
              parseInt(item.qty),
              parseInt(item.userDefine1),
              parseInt(item.userDefine2),
            ]);
          });
        }
        this.loading = false;

        let workSheet = "";
        await (workSheet = XLSX.utils.aoa_to_sheet(data));
        let workBook = XLSX.utils.book_new();
        await XLSX.utils.book_append_sheet(workBook, workSheet, "1");
        await XLSX.writeFile(workBook, "库存数据导出.xlsx");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
